import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCharacterTopologies', 'characterTopologies'),
}
